/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { SignInProps } from "@/@types";
import { Alert } from "@/components/Modal";
import { Form } from "@/components/Form";
import {
  Typography,
  Stack,
  Link,
  Card,
  Container,
  Button,
  Dialog,
  TextField,
  useTheme,
} from "@mui/material";
import { IAlertData } from "@/@types/Alert";
import { UI_ACTION_STATE } from "@/store/common";
import { useAccount, useWalletClient } from "wagmi";
import { useWeb3Modal } from "@web3modal/react";

const SignInPage = (props: SignInProps) => {
  const theme = useTheme();
  const nevigate = useNavigate();

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [openResendEmail, setOpenResendEmail] = useState(false);
  const [alertData, setAlertData] = useState<undefined | IAlertData>();
  const signer = useWalletClient();
  const { address } = useAccount();
  const { open, isOpen } = useWeb3Modal();
  const [openWallet, setOpenWallet] = useState(false);
  const location = useLocation();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSubmit = async (e: any) => {
    if (e) e.preventDefault();

    try {
      if (!address) {
        setOpenWallet(true);
        await open();
        return;
      }
      props.commonStore.setActionState(
        UI_ACTION_STATE.WALLET_CONFIRMATION_PENDING,
      );
      const nonce = Date.now();
      const signature = await signer.data?.signMessage({
        message: nonce.toString(),
      });
      props.commonStore.setActionState(UI_ACTION_STATE.PLEASE_WAIT);
      const isVerified = await props.userStore.signIn({
        address: address || "",
        signature: signature || "",
        nonce: nonce.toString(),
      });
      if (isVerified) {
        setAlertData({
          message: "Successfully sign in",
          button: {
            text: "go to trade page",
            method: () => {
              if (location.pathname.includes("sign-in")) {
                // nevigate("/trade");
                window.location.href = "/#/trade";
                window.location.reload();
              } else {
                nevigate(location.pathname);
              }
            },
          },
        });
      } else {
        setAlertData({
          message: "Successfully sign in",
          button: {
            text: "go to profile",
            method: () => {
              window.location.href = "/#/profile";
              window.location.reload();
            },
          },
        });
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      props.commonStore.setActionState(UI_ACTION_STATE.NONE);
      if (e.code === 401) {
        if (e.trace?.response?.data?.message === "email not verified") {
          setAlertData({
            message:
              "Your email is not verified. Please check your email to verify your email address.",
            closeMethod: () => {
              setAlertData(undefined);
            },
          });
          return;
        } else if (e.trace?.response?.data?.message === "user not found") {
          setAlertData({
            message: "Account not found. Please sign up first.",
            closeMethod: () => {
              setAlertData(undefined);
            },
          });
          return;
        }
      } else if (
        typeof e.message === "string" &&
        e.message.includes("user rejected signing")
      ) {
        setAlertData({
          message: "Sign in failed: User rejected signing.",
          closeMethod: () => {
            setAlertData(undefined);
          },
        });
        return;
      } else {
        setAlertData({
          message: "Sign in failed: " + e.message,
          closeMethod: () => {
            setAlertData(undefined);
          },
        });
      }
    }
    props.commonStore.setActionState(UI_ACTION_STATE.NONE);
  };

  function resendVerificationEmail(e: any): void {
    e.preventDefault();
    if (!email) {
      setEmailError("Please enter your email address.");
      return;
    }
    setOpenResendEmail(false);
    props.commonStore.setActionState(UI_ACTION_STATE.PLEASE_WAIT);
    props.userStore
      .resendEmail(email)
      .then(() => {
        props.commonStore.setActionState(UI_ACTION_STATE.NONE);
        setAlertData({
          message:
            "Verification email sent! Please check your email (it may be in the spam folder).",
          closeMethod: () => {
            setAlertData(undefined);
          },
        });
      })
      .catch((e: any) => {
        props.commonStore.setActionState(UI_ACTION_STATE.NONE);
        setAlertData({
          message: "Resend verification email failed: " + e.message,
          closeMethod: () => {
            setAlertData(undefined);
          },
        });
      });
  }
  useEffect(() => {
    if (!signer.isLoading && openWallet && !isOpen && address) {
      setOpenWallet(false);
      handleSubmit(null);
    }
  }, [address, isOpen, openWallet, signer.isLoading]);
  return (
    <Container
      sx={{
        maxWidth: "670px",
        py: "82px",
        [theme.breakpoints.up("lg")]: { maxWidth: "670px", py: "82px" },
      }}
    >
      <Card
        sx={{
          maxWidth: "670px",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <Typography variant="h2">Sign In</Typography>

        <Stack
          direction="row"
          gap="20"
          sx={{
            justifyContent: "space-around",
          }}
        >
          <Button onClick={handleSubmit} size="large" variant="contained">
            Sign In with Wallet
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              nevigate("/sign-up");
            }}
            size="large"
          >
            Sign Up
          </Button>
        </Stack>
        <Stack
          direction={"row"}
          gap={2}
          sx={{
            mt: "2.75rem",
            justifyContent: "center",
          }}
        >
          <Link component={"button"} onClick={() => setOpenResendEmail(true)}>
            Resend verification email
          </Link>
        </Stack>
      </Card>
      {alertData && <Alert alertData={alertData} />}
      {/* Dialog input email to resend verification email */}
      <Dialog open={openResendEmail} onClose={() => setOpenResendEmail(false)}>
        <Card
          sx={{
            maxWidth: "670px",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <Typography variant="h2">Resend Verification Email</Typography>
          <Form
            onSubmit={resendVerificationEmail}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <TextField
              label="Email"
              variant="outlined"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              error={!!emailError}
              helperText={emailError}
            />
            <Stack
              direction="row"
              gap="20"
              sx={{
                justifyContent: "space-around",
              }}
            >
              <Button type="submit" size="large" variant="contained">
                Resend Verification Email
              </Button>
            </Stack>
          </Form>
        </Card>
      </Dialog>
    </Container>
  );
};

export default SignInPage;
